var map = {
	"./VR.png": 3075,
	"./bottom.png": 8487,
	"./close-white.png": 7478,
	"./file.png": 8332,
	"./index.png": 3476,
	"./manage.png": 5402,
	"./manager-select.png": 7017,
	"./manager.png": 5926,
	"./member.png": 3321,
	"./menu-select.png": 5775,
	"./menu.png": 7335,
	"./order.png": 2397,
	"./pet-select.png": 1948,
	"./pet.png": 6581,
	"./platformlevel.png": 3767,
	"./platformmenu.png": 1362,
	"./platformshop.png": 5529,
	"./record.png": 9122,
	"./setting-select.png": 3293,
	"./setting.png": 3258,
	"./stat.png": 3889,
	"./sysbase.png": 2440,
	"./sysmall.png": 4205,
	"./tools.png": 7820,
	"./visit.png": 5303,
	"./wallet.png": 4732,
	"./xcx.png": 1598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9488;